module.exports = "/fonts/../fonts/sio-logo-full.svg?80ec6cf11d90b09e2a98d059dd066b8f";